import {
  ApolloClient,
  InMemoryCache,
  createHttpLink,
  from,
} from '@apollo/client';
import { setContext } from '@apollo/client/link/context';
import { onError } from '@apollo/client/link/error';

// HTTP link
const httpLink = createHttpLink({
  uri: '/graphql', // Use relative URL to work with Cloudflare Pages proxy
  credentials: 'include', // Include cookies for session authentication
});

// Auth link to add authentication headers
const authLink = setContext((_, { headers }) => {
  // Get token from localStorage
  const token = localStorage.getItem('access_token');

  // Return headers with auth token if available
  return {
    headers: {
      ...headers,
      ...(token && { authorization: `Bearer ${token}` }),
      // Add CSRF token for session-based requests
      'X-Requested-With': 'XMLHttpRequest',
    },
  };
});

// Error link to handle auth errors
const errorLink = onError(
  ({ graphQLErrors, networkError, operation, forward }) => {
    if (graphQLErrors) {
      graphQLErrors.forEach(({ message, locations, path, extensions }) => {
        console.error(
          `[GraphQL error]: Message: ${message}, Location: ${locations}, Path: ${path}`,
        );

        // Handle authentication errors
        if (
          extensions?.code === 'UNAUTHENTICATED' ||
          message.includes('Unauthorized')
        ) {
          // Clear auth state and redirect to login
          localStorage.removeItem('access_token');
          localStorage.removeItem('refresh_token');
          localStorage.removeItem('user');
          window.location.href = '/login';
        }
      });
    }

    if (networkError) {
      console.error(`[Network error]: ${networkError}`);

      // Handle 401 errors
      if ('statusCode' in networkError && networkError.statusCode === 401) {
        localStorage.removeItem('access_token');
        localStorage.removeItem('refresh_token');
        localStorage.removeItem('user');
        window.location.href = '/login';
      }
    }
  },
);

const client = new ApolloClient({
  link: from([errorLink, authLink, httpLink]),
  cache: new InMemoryCache({
    typePolicies: {
      Query: {
        fields: {
          block: {
            keyArgs: ['number'],
            merge(existing, incoming, { mergeObjects }) {
              return mergeObjects(existing, incoming);
            },
          },
        },
      },
    },
  }),
  defaultOptions: {
    watchQuery: {
      errorPolicy: 'all',
    },
    query: {
      errorPolicy: 'all',
    },
  },
});

export default client;
